// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__6ub3Q"};